import styled from 'styled-components';

export const BaseItem = styled.div`
  height: 24px;
  width: 69px;
  color: white;
  text-align: center;
  font-size: 1rem;
  line-height: normal;
  float: left;
  border: 1px dashed #fff;
  backdrop-filter: 20px;
  box-shadow: 0px 2px 15px 0 rgba(0, 0, 0, 0.16);
  border-radius: 5px;
  line-height: 22px;
  position: relative;
`;

export const BaseWrapper = styled.div`
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;

  svg {
    display: block;
    margin: 2px auto 0;
  }

  &.base-1 {
    top: 52%;
    right: 23.5%;
  }

  &.base-2 {
    top: 39%;
  }

  &.base-3 {
    top: 52%;
    left: 23.5%;
  }

  &.with-player {
    &.base-1 {
      top: 52%;
      right: 25.5%;
    }

    &.base-2 {
      top: 39%;
      left: 41%;
    }

    &.base-3 {
      top: 52%;
      left: 22%;
    }
  }

  &:not(.with-player):hover {
    cursor: pointer;
  }

  &.with-player {
    ${BaseItem} {
      border: none;
    }
  }
`;
